
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import da from './locales/da.json';
import enNav from './locales/nav/en.json';
import daNav from './locales/nav/da.json';
import enAbout from './locales/about/en.json';
import daAbout from './locales/about/da.json';
import enFaq from './locales/faq/en.json';
import daFaq from './locales/faq/da.json';
import enSupport from './locales/support/en.json';
import daSupport from './locales/support/da.json';
import enPricing from './locales/pricing/en.json';
import daPricing from './locales/pricing/da.json';
import enLogin from './locales/login/en.json';
import daLogin from './locales/login/da.json';
import enSignup from './locales/signup/en.json';
import daSignup from './locales/signup/da.json';
import enRequestDemo from './locales/request-demo/en.json';
import daRequestDemo from './locales/request-demo/da.json';
import enCompetitorAnalysis from './locales/competitor-analysis/en.json';
import daCompetitorAnalysis from './locales/competitor-analysis/da.json';
import enLegal from './locales/legal/en.json';
import daLegal from './locales/legal/da.json';
import enTenderManagement from './locales/tender-management/en.json';
import daTenderManagement from './locales/tender-management/da.json';
import enProfile from './locales/profile/en.json';
import daProfile from './locales/profile/da.json';
import enTenderAgent from './locales/tender-agent/en.json';
import daTenderAgent from './locales/tender-agent/da.json';
import enLanding from './locales/landing/en.json';
import daLanding from './locales/landing/da.json';
import enPlatform from './locales/platform/en.json';
import daPlatform from './locales/platform/da.json';
import enContact from './locales/contact/en.json';
import daContact from './locales/contact/da.json';
import enPrivacy from './locales/privacy/en.json';
import daPrivacy from './locales/privacy/da.json';
import enTerms from './locales/terms/en.json';
import daTerms from './locales/terms/da.json';
import enOfferManagement from './locales/offer-management/en.json';
import daOfferManagement from './locales/offer-management/da.json';
import enTenderDocuments from './locales/tender-documents/en.json';
import daTenderDocuments from './locales/tender-documents/da.json';
import enTenderView from './locales/tender-view/en.json';
import daTenderView from './locales/tender-view/da.json';
import enOpportunityFinder from './locales/opportunity-finder/en.json';
import daOpportunityFinder from './locales/opportunity-finder/da.json';

// Initialize i18next with Danish as default language
i18n
  .use(LanguageDetector) // Automatically detect language
  .use(initReactI18next)
  .init({
    resources: {
      en: { 
        translation: en,
        nav: enNav,
        about: enAbout,
        faq: enFaq,
        support: enSupport,
        pricing: enPricing,
        login: enLogin,
        signup: enSignup,
        requestDemo: enRequestDemo,
        competitorAnalysis: enCompetitorAnalysis,
        legal: enLegal,
        tenderManagement: enTenderManagement,
        profile: enProfile,
        tenderAgent: enTenderAgent,
        landing: enLanding,
        platform: enPlatform,
        contact: enContact,
        privacy: enPrivacy,
        terms: enTerms,
        offerManagement: enOfferManagement,
        tenderDocuments: enTenderDocuments,
        tenderView: enTenderView,
        opportunityFinder: enOpportunityFinder
      },
      da: {
        translation: da,
        nav: daNav,
        about: daAbout,
        faq: daFaq,
        support: daSupport,
        pricing: daPricing,
        login: daLogin,
        signup: daSignup,
        requestDemo: daRequestDemo,
        competitorAnalysis: daCompetitorAnalysis,
        legal: daLegal,
        tenderManagement: daTenderManagement,
        profile: daProfile,
        tenderAgent: daTenderAgent,
        landing: daLanding,
        platform: daPlatform,
        contact: daContact,
        privacy: daPrivacy,
        terms: daTerms,
        offerManagement: daOfferManagement,
        tenderDocuments: daTenderDocuments,
        tenderView: daTenderView,
        opportunityFinder: daOpportunityFinder
      }
    },
    fallbackLng: 'da', // Changed default fallback to Danish
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
    }
  });

// Force set to Danish by default
i18n.changeLanguage('da');

export default i18n;
